import angular from 'angular'
import './tips.service'
import './edit/edit.controller'

angular
  .module('admin.tips', ['admin.tips.edit', 'admin.tips.service'])
  .controller('TipsAdminCtrl', TipsAdminCtrl)

/** @ngInject */
function TipsAdminCtrl(
  $scope,
  $state,
  $stateParams,
  TipsAdminService,
  CacheService,
  UploadService,
) {
  var vm = this
  vm.items = []
  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.create = false
  vm.model = {}
  vm.totalUsers = 0
  vm.usersPerPage = 25
  vm.oldPage = 0
  vm.currentPage = 25
  vm.first = true
  vm.totalItems = 0
  vm.pagination = {
    current: 1,
  }

  vm.sortType = 'n-asc'
  vm.sortReverse = false

  load(1)

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    TipsAdminService.list(vm.oldPage, 25, vm.sortType).then(function(result) {
      var posts = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < posts.length; i++) {
        posts[i].editing = false
        posts[i].loadT = false
        posts[i].loadH = false
        if (posts[i].st === 1) {
          posts[i].isPub = true
          posts[i].isArchived = false
        } else if (posts[i].st === 2) {
          posts[i].isPub = false
          posts[i].isArchived = true
        } else {
          posts[i].isPub = false
          posts[i].isArchived = false
        }
        posts[i].ts = new Date(
          parseInt(posts[i].ts.toString().substring(0, posts[i].ts.toString().length - 3)),
        )
      }

      vm.sortType = oldSortType
      vm.items = posts
      vm.disableTable = false
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  vm.add = function() {
    $state.go('admin.tips.edit', { id: 0 })
  }

  vm.edit = function(item) {
    $state.go('admin.tips.edit', { id: item.id })
  }

  vm.save = function() {
    if (!vm.model.locale) {
      delete vm.model.locale
    }
    if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
      TipsAdminService.update(vm.model.id, vm.model).then(function() {
        $('#callModal').click()
        load(vm.pagination.current)
      })
    } else {
      delete vm.model.id
      delete vm.model.editing
      TipsAdminService.save(vm.model).then(function() {
        $('#callModal').click()
        load(vm.pagination.current)
      })
    }
  }

  vm.cancel = function(item) {
    if (item.id === 0) {
      vm.items.remove(item)
    }
    item.editing = !item.editing
    vm.create = false
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          TipsAdminService.remove(item.id).then(function() {
            if (vm.items.length === 1 || vm.items.length === 25) {
              $state.reload()
            } else {
              load(vm.pagination.current)
            }
          })
        } else {
          return
        }
      },
    )
  }

  vm.publish = function(item) {
    TipsAdminService.update(item.id, { st: 1 }).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.archive = function(item) {
    TipsAdminService.update(item.id, { st: 2 }).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.uploadT = function(item) {
    item.loadT = true
    UploadService.save('tips', vm.pathImgT, 'img-t', item.id).then(function(fileName) {
      item.loadT = false
      item['img-t'] = fileName
    })
  }

  vm.uploadH = function(item) {
    item.loadH = true
    UploadService.save('tips', vm.pathImgH, 'img-h', item.id).then(function(fileName) {
      item.loadH = false
      item['img-h'] = fileName
    })
  }

  vm.back = function() {
    load(vm.pagination.current)
  }

  vm.showDescription = function(item) {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function() {
      $('#description').text(item)
    })
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 150,
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true
      vm.orderList(evt)
    },
  }

  vm.orderList = function(evt) {
    for (var i = 0; i < vm.items.length; i++) {
      vm.items[i].o = parseInt(evt.newIndex) + 1
      if (vm.items[i].id === evt.model.id) {
        vm.update(evt.model)
      }
    }
  }

  vm.update = function(model) {
    TipsAdminService.update(model.id, { n: model.o }).then(function() {
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      load(vm.pagination.current)
    })
  }

  vm.removeImg = function(type, model) {
    if (type === 't') {
      model['img-t'] = ''
    } else {
      model['img-h'] = ''
    }
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    load(vm.pagination.current)
  }
}
